module.exports = __webpack_public_path__ + "static/media/pos_in_action_h.2ad19f92.jpg";